import { render } from "./AvatarComponent.vue?vue&type=template&id=5cc2d298&scoped=true"
import script from "./AvatarComponent.vue?vue&type=script&lang=js"
export * from "./AvatarComponent.vue?vue&type=script&lang=js"

import "./AvatarComponent.vue?vue&type=style&index=0&id=5cc2d298&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5cc2d298"]])

export default __exports__